<template>
  <div v-if="show" :class="`warning-container ${variant}`">
    <div class="content-container">
      <InfoIcon v-if="showInfoIcon" class="icon" />
      <SuccessIcon v-if="variant === UPDATED_STATUS_WARNING_VARIANTS.SUCCESSFUL" class="icon" />
      <div>
        {{ message }}
      </div>
    </div>
    <div class="clear-icon-container" @click="$emit('close')">
      <ClearIcon />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import InfoIcon from '@/components/icons/InfoIcon.vue';
import SuccessIcon from '@/components/icons/SuccessIcon.vue';
import ClearIcon from '@/components/icons/ClearIcon.vue';
import { UPDATED_STATUS_WARNING_VARIANTS, UpdatedStatusWarningVariant } from '@/common/transaction-utils';

const props = withDefaults(
  defineProps<{
    show: boolean;
    message: string;
    variant?: UpdatedStatusWarningVariant;
  }>(),
  {
    variant: UPDATED_STATUS_WARNING_VARIANTS.WARNING,
  }
);

const showInfoIcon = computed(() => {
  return (
    props.variant === UPDATED_STATUS_WARNING_VARIANTS.PROMINENT ||
    props.variant === UPDATED_STATUS_WARNING_VARIANTS.WARNING
  );
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/variable.scss';

.warning-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
  gap: 8px;

  &.warning {
    color: $tr-item-updated-status-warning-color;
    background-color: $tr-item-updated-status-warning-background;

    .icon {
      color: $tr-item-updated-status-warning-icon-color;
    }
  }

  &.prominent {
    color: $tr-item-updated-status-prominent-color;
    background-color: $tr-item-updated-status-prominent-background;

    .icon {
      color: $tr-item-updated-status-prominent-icon-color;
    }
  }

  &.successful {
    color: $tr-item-updated-status-success-color;
    background-color: $tr-item-updated-status-success-background;

    .icon {
      color: $tr-item-updated-status-success-icon-color;
    }
  }
}

.content-container {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: $size-xs;
  line-height: 16px;
}

.clear-icon-container {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
}
</style>
